import CircularProgress from '@mui/material/CircularProgress'

import { StyledTableCell,StyledTableRow } from './styles'

const View = ({ colSpan }: { colSpan: number }) => {
  return (
    <StyledTableRow data-testid="top-coins-loading">
      <StyledTableCell colSpan={colSpan} align="center">
        <CircularProgress />
      </StyledTableCell>
    </StyledTableRow>
  )
}

export default View
